import { useLocation, useOutlet } from 'react-router-dom';
import { AnimatePresence, m } from 'motion/react';
import Header from './Header';
import Footer from './Footer';
import Breadcrumbs from './Breadcrumbs';
import { useEffect, useRef } from 'react';
import {
  ANIM_BOTTOM,
  ANIM_CONTENT,
  ANIM_TOP,
  FRAME,
  getContentTransition,
} from '../../constants/layoutAnimations';

const STEP_ORDER = ['/verify-email', '/register'];

const Layout = () => {
  const location = useLocation();
  const outlet = useOutlet();

  const previous = useRef(null);

  const from = STEP_ORDER.indexOf(previous.current);
  const to = STEP_ORDER.indexOf(location.pathname);

  const direction = previous.current === null ? 0 : Math.sign(to - from);

  useEffect(() => {
    previous.current = location.pathname;
  }, [location.pathname]);

  return (
    <m.div className="app-layout" variants={FRAME} initial="hidden" animate="visible">
      <m.div className="app-layout__header" variants={ANIM_TOP}>
        <Header />
      </m.div>

      <m.div className="app-layout__steps" variants={ANIM_TOP}>
        <Breadcrumbs />
      </m.div>

      <AnimatePresence mode="wait" custom={direction}>
        <m.main
          className="app-content"
          custom={direction}
          variants={ANIM_CONTENT}
          key={location.pathname}
          initial="initial"
          animate="animate"
          exit="exit"
          transition={getContentTransition(direction)}
        >
          {outlet}
        </m.main>
      </AnimatePresence>

      <m.div variants={ANIM_BOTTOM}>
        <Footer />
      </m.div>
    </m.div>
  );
};

export default Layout;
